// Format table's column name for translation map, e.g. 'User type' -> table.User_type
export const formatTableColumn = (text) => {
  if(!text) return undefined;
  return 'table.' + text.replace(/ /g, '_');
};
